import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AgentsService } from '@app/home/services/agents.service';

import * as teamActions from '../actions';
import { of, switchMap } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class TopTeamEffects {

  getTopTeam$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(teamActions.getTopTeam),
      switchMap((filter: any) => {
        return this.agentService.getAgentGroups(filter).pipe(
          map((data: any) => {
            return teamActions.getTopTeamSuccess({ topTeam: data.data.data, totalCount: data.total });
          }),
          catchError((err) => of(teamActions.getTopTeamFailure({ errorMessage: err.message }))),
        );
      }),
    );
  });

  getMoreTopTeam$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(teamActions.getMoreTopTeam),
      switchMap((filter: any) => {
        return this.agentService.getAgentGroups(filter).pipe(
          map((data: any) => {
            return teamActions.getMoreTopTeamSuccess({ topTeam: data.data.data, totalCount: data.total });
          }),
          catchError((err) => of(teamActions.getMoreTopTeamFailure({ errorMessage: err.message }))),
        );
      }),
    );
  });

  constructor(
    private actions$: Actions,
    private agentService: AgentsService,
  ) {}
}
